var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-row", { staticClass: "row" }, [
    _c(
      "div",
      { staticStyle: { width: "30%" }, style: _vm.columnStyle },
      [
        _c("div", { staticClass: "q-toolbar" }, [
          _c(
            "div",
            { staticClass: "q-toolbar-buttons" },
            [
              _c(
                "q-button",
                {
                  staticClass: "q-toolbar-btn",
                  on: { click: _vm.newParentMenu },
                },
                [_c("font-awesome-icon", { attrs: { icon: ["fas", "plus"] } })],
                1
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  staticClass: "q-toolbar-btn",
                  on: { click: _vm.refreshMenus },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: ["fas", "sync-alt"] },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "q-input",
                {
                  attrs: {
                    placeholder: this.$qt("menuEditor.searchPlaceHolder"),
                  },
                  model: {
                    value: _vm.filterText,
                    callback: function ($$v) {
                      _vm.filterText = $$v
                    },
                    expression: "filterText",
                  },
                },
                [
                  _c("q-button", {
                    attrs: {
                      slot: "append",
                      type: "info",
                      icon: "q-icon-search",
                    },
                    slot: "append",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("q-menu-bar", {
          staticClass: "q-menu-vertical-Dash menu-tree",
          attrs: {
            router: false,
            menus: _vm.menus,
            "is-collapse": false,
            width: "400",
            "fore-color": "black",
            "active-text-color": "red",
          },
          on: { "item-select": _vm.menuSelected },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { width: "70%" }, style: _vm.columnStyle },
      [_c("q-json", [_vm._v(_vm._s(_vm.currentMenu))])],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }